import { message } from "antd";
import { getAxiosInstance } from "../ApiConfig";

async function FetchAllAccount() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllAccountsByReportingUsers`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllAccountPagination(page, limit) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllAccountsByReportingUsers?page=${page}&limit=${limit}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllAccountSearch(search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllAccountsByReportingUsers?search=${search}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllAccountPaginationSearch(page, limit, search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllAccountsByReportingUsers?page=${page}&limit=${limit}&search=${search}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllAccountType() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllAccountType`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllOwnership() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllOwnership`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllCustomerstatus() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllCustomerStatus`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getOwnerChange(userId, accountId) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/checkAccountIsInGoals/${userId}/${accountId}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getCompanyAccount() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllAccountsByCompany`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function FetchAccountDetails(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getByAccountsId/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AccountScoreData(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAccountScoreByAccountId/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function AccountsByAccountType() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllAccountsByAccountType`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function AccountConnectioncheck(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/findAccountConnections`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AccountMergerUpadet(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateAccountsInMerge/${id}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function mergeAccountDelte(payload) {
    try {
        const response = await getAxiosInstance().delete(`/usermgmt/deleteAccountInMerge`, { data: payload })
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function massUpdateAccount(payload) {
    try {
        const { actionType, ...body } = payload;
        const url = actionType
            ? `/usermgmt/massUpdateAccount?actionType=${actionType}`
            : `/usermgmt/massUpdateAccount`;
        const response = await getAxiosInstance().put(url, body);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function massDeleteAccount(payload) {
    try {
        const response = await getAxiosInstance().delete(`/usermgmt/massDeleteAccount`, { data: payload })
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function createAccounts(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createAccounts`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function updateAccounts(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateAccounts/${id}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function UpdateRelatedModule(ownerId, newOwnerId, accountId, accountName, payload = {}) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/transferAccountOwner/${ownerId}/${newOwnerId}/${accountId}/${accountName}`, payload);
        return response;
    } catch (err) {
        message.error("Email connection error. Update your settings to restore access")
    }
};
async function generateAccountDescription(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/generateAccountDescription`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
export {
    massDeleteAccount,
    massUpdateAccount,
    FetchAllAccount,
    FetchAllAccountType,
    FetchAllOwnership,
    getOwnerChange,
    FetchAllCustomerstatus,
    getCompanyAccount,
    FetchAccountDetails,
    AccountScoreData,
    AllAccountPagination,
    AllAccountPaginationSearch,
    FetchAllAccountSearch,
    AccountConnectioncheck,
    mergeAccountDelte,
    AccountMergerUpadet,
    AccountsByAccountType,
    updateAccounts,
    createAccounts,
    UpdateRelatedModule,
    generateAccountDescription
}